import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import { NavigationItemProvider } from './context/NavigationItemProvider';
import type { NavigationItemProviderProps } from './context/NavigationItemProvider';
import type { SourceProviderProps } from './context/SourceProvider';
import { SourceProvider } from './context/SourceProvider';
import Center from './layout/Center';
import Navigation from './layout/Navigation';

export interface ImageLibraryProps
  extends Omit<SourceProviderProps, 'children'>,
    Omit<NavigationItemProviderProps, 'children'> {}

const ImageLibrary = ({
  features = {},
  imageSize,
  initial,
  isPendingChecks,
  networkId,
  onClose,
  onSave,
  onUpload,
  updateModalTitle,
}: ImageLibraryProps) => (
  <NavigationItemProvider
    features={features}
    updateModalTitle={updateModalTitle}
  >
    <SourceProvider
      imageSize={imageSize}
      initial={initial}
      isPendingChecks={isPendingChecks}
      networkId={networkId}
      onClose={onClose}
      onSave={onSave}
      onUpload={onUpload}
    >
      <Wrapper>
        <Navigation />
        <Center />
      </Wrapper>
    </SourceProvider>
  </NavigationItemProvider>
);

export default ImageLibrary;

const Wrapper = styled(Box).attrs(() => ({
  height: '100%',
  width: '100%',
}))`
  overflow-y: scroll;
`;
